import { Module } from 'vuex';
import { getters } from '../getters/entity.getters';
import { RootState } from '../store';
import { actions } from '@/store/actions/entity.actions';
import { mutations } from '@/store/mutations/entity.mutations';
import { IUser } from '@/types/User';
import { ITeam } from '@/types/Team';
import { IPlanStatus } from '@/types/plan-status';
import { IEntity } from '@/types/Entity';

export const namespace = 'entity';

export interface IEntityState {
  entityId: string;
  isLoading: boolean;
  users: IUser[];
  teams: ITeam[];
  isLoadingTeams: boolean;
  planStatus: IPlanStatus;
  entity: IEntity;
}

export const state: IEntityState = {
  entityId: '',
  isLoading: false,
  users: [],
  teams: [],
  isLoadingTeams: false,
  planStatus: undefined,
  entity: {
    logoUrl: '',
    theme: {
      name: '',
      accentColor: '',
      backgroundColor: '',
      backgroundImage: '',
      signButtonText: '',
    },
  },
};

const namespaced: boolean = true;

export const entity: Module<IEntityState, RootState> = {
  actions,
  getters,
  namespaced,
  mutations,
  state,
};
